export default __webpack_public_path__ + "static/webinar-ec8ee0c8b937c9befc5a94bff029a958.svg";